import 'date-fns';
import React from 'react';

// OUTSIDE COMPONENTS
import { KeyboardDatePicker } from '@material-ui/pickers';

export default function DateCalendarField(props) {
  let cDate;
  if (props.minDate == null) {
    cDate = '1900-01-01';
  } else {
    cDate = props.minDate;
  }

  return (
    <KeyboardDatePicker
      required={props.required}
      id={props.id}
      fullWidth={props.fullWidth}
      className={`text-nowrap ${props.class} `}
      format='dd.MM.yyyy'
      margin={props.margin} //"normal"
      label={props.labelText}
      InputLabelProps={props.inputLabelProps}
      value={props.valueInput}
      onChange={props.onChangeInput}
      KeyboardButtonProps={{
        'aria-label': 'change date',
        style: { outline: 'none' }
      }}
      minDate={cDate}
      maxDate={props.maxDate}
      autoOk
      invalidDateMessage={props.invalidDateMessage}
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
      }}
    />
  );
}
